import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Breadcrumb from './Breadcrumb';
import './Layout.scss';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Helper: Render FAQ CTA if on /faq
  const renderFaqCta = () => (
    <section className="faq__cta">
      <div className="faq__cta-content">
        <h2 className="faq__cta-title">Still have questions?</h2>
        <p className="faq__cta-text">Our team is here to help you 24/7. Reach out for a free consultation and get expert advice for your next project.</p>
        <div className="faq__cta-buttons">
          <a href="/contact" className="faq__cta-btn faq__cta-btn--primary">Contact Us</a>
        </div>
      </div>
    </section>
  );
  const location = useLocation();
  
  // Check if we're on the home page
  const isHomePage = location.pathname === '/' || location.pathname === '/home';
  
  // Check if we're on blogs page or blog details page
  const isBlogPage = location.pathname === '/blogs' || location.pathname.startsWith('/blog/') || location.pathname.startsWith('/blogs/');
  
  // Check if we're on a service page
  const isServicePage = location.pathname.startsWith('/services/');

  // Get the page class name
  const getPageClassName = () => {
    if (isHomePage) return 'layout__content--home';
    if (location.pathname === '/full-stack-expert' || location.pathname === '/who-we-are') {
      return 'layout__content--who-we-are';
    }
    if (location.pathname === '/development-process') return 'layout__content--development-process';
    if (location.pathname === '/development-reviews') return 'layout__content--reviews';
    if (location.pathname === '/write-review') return 'layout__content--write-review';
    if (location.pathname === '/portfolio') return 'layout__content--portfolio';
    if (location.pathname === '/pricing') return 'layout__content--pricing';
    if (isServicePage) return 'layout__content--service';
    if (isBlogPage) return 'layout__content--blogs';
    if (location.pathname === '/faq') return 'layout__content--faq';
    if (location.pathname === '/contact') return 'layout__content--contact';
    return '';
  };

  return (
    <div className="layout">
      <Header />
      <Breadcrumb />
      {/* Main Content */}
      <main 
        className={`layout__main ${
          isServicePage ? 'layout__main--service' : ''
        } ${
          isBlogPage ? 'layout__main--blogs' : ''
        } ${
          location.pathname === '/faq' ? 'layout__main--faq' : ''
        } ${
          location.pathname === '/portfolio' ? 'layout__main--portfolio' : ''
        } ${
          location.pathname === '/pricing' ? 'layout__main--pricing' : ''
        } ${
          location.pathname === '/development-process' ? 'layout__main--development-process' : ''
        } ${
          location.pathname === '/contact' ? 'layout__main--contact' : ''
        }`}
      >
        <div className={`layout__content ${getPageClassName()}`}>
          {children}
        </div>
      </main>
      {/* Render FAQ CTA outside main content for /faq only */}
      {location.pathname === '/faq' && renderFaqCta()}
      <Footer />
    </div>
  );
};

export default Layout;
